import useGetHasAcknowledgedByActivityKey from '../providers/ActivityAcknowledgement/useGetHasAcknowledgedByActivityKey';

export default useGetHasAcknowledgedByActivityKey;
